import React from 'react';

export default function BellIcon({className}) {
	return (
        <svg className={className ? className : ''} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.8 18.1" preserveAspectRatio="xMidYMid meet"><path d="M16.8 12.3c0 1.1-.9 1.9-1.9 1.9h-13c-1.1 0-2-.8-2-1.9s.8-2 1.9-2h.1V6.5C1.9 2.9 4.8 0 8.4 0s6.5 2.9 6.5 6.5v3.9c1.1 0 1.9.8 1.9 1.9zm-1.9-.7c-.7 0-1.3-.6-1.3-1.3V6.5c0-2.9-2.3-5.2-5.2-5.2S3.2 3.6 3.2 6.5v3.9c0 .7-.6 1.3-1.3 1.3-.4 0-.6.3-.6.6s.3.6.6.6h12.9c.4 0 .6-.3.6-.6s-.2-.7-.5-.7zm-9.4 3.6h1.3c0 .9.7 1.6 1.6 1.6.9 0 1.6-.7 1.6-1.6h1.3c0 1.6-1.3 2.9-2.9 2.9-1.6 0-2.9-1.3-2.9-2.9z"/></svg>
	);
}
